/*
This module is used with : Hop/services/tracking/track-text-selection.js

In template, add :
data-js="{
    track-text-selection : {
        gtm: {} // the gtm code you'll use to track the user selection, it's required
        elementToTrack: '.my-dom-selector' // it's not required. If you don't set this, it will choose the root element by default
        contentToTrackIsAsync: true // it's not required, but use it when the content is loaded asynchronously. You'll need to trigger an event manually (1)
        trackFullSelection: false // not required, default to true
    }
}"

(1) : import the event const from the service file, then => Hop.events.trigger(SELECTION_TRACKING_CONTENT_READY, asynchronous-content-to-track);
asynchronous-content-to-track is not required, it will be used with fullContentToCompareWithSelection when you need to track only the full selection of your content
*/

import {TrackTextSelection} from '../../services/track-text-selection';

Hop.defineModule('track-text-selection', (root, params) => {
    checkParameters();
    const trackTextSelection = new TrackTextSelection(root, params);

    function checkParameters() {
        if (!params.gtm) {
            throw new Error('No parameters specified for tracking. You need at least to specify a gtm object');
        }
    }

    return function destroy() {
        trackTextSelection.destroy();
    };
});
